<template>
    <div>
        <h1 
            v-if="!builds.length"
            class="infinity-text pt-0 pa-12"
            style="text-align: center"
            v-html="'No builds yet'"
        />         
        <div v-else>
            <div v-if="$route.params.jobId === 'running'">
                <div v-if="logs">
                    <infinity-separator
                        icon="mdi-text-long"
                        text="Running build logs"
                    />
                    <log-viewer 
                        :log="logs"
                    />
                </div>
                <h1 
                    v-else
                    class="infinity-text pt-0 pa-12"
                    style="text-align: center"
                >
                    No build logs found
                </h1>
            </div>            
            <v-container 
                v-else-if="history.State === 'NoBuild'"
                class="px-6"
            >                
                <infinity-separator
                    icon="mdi-robot"
                    :text="`Build #${history.ID }`"
                />
                <h2 class="mt-4">
                    Used images
                </h2>
                <v-list>
                    <v-list-item 
                        v-for="tag in tags"
                        :key="tag.tag"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-oci</v-icon>
                        </v-list-item-icon>
                        <v-list-item-text
                            style="width: 100%"
                        >
                            <v-text-field 
                                style="width: 100%"
                                solo
                                outlined
                                read-only
                                :value="tag.tag" 
                            />
                        </v-list-item-text>
                    </v-list-item>
                </v-list>
                <v-tabs 
                    v-model="tab"
                    class="mt-4"
                > 
                    <v-tab>Logs</v-tab>
                    <v-tab>App Config</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item>                    
                        <log-viewer 
                            :log="history.Logs || ''"
                        />
                    </v-tab-item>
                    <v-tab-item>                                            
                        <v-form>                         
                            <v-jsf 
                                v-if="model.name"
                                v-model="model" 
                                :schema="schema" 
                                :options="options"
                                class="vjsf"
                            />                            
                        </v-form>
                    </v-tab-item>
                </v-tabs-items>
            </v-container>
            <div v-else>
                <div v-if="logs">
                    <infinity-separator
                        icon="mdi-text-long"
                        text="Running build logs"
                    />
                    <log-viewer 
                        :log="logs"
                    />
                </div>
                <v-container
                    v-else
                >
                    <v-card
                        flat
                        tile
                        class="rounded-t"
                        :color="history.State === 'Failed' ? 'error' : 'grey lighten-2'"
                    >
                        <infinity-separator
                            :icon="history.State === 'Failed' ? 'mdi-robot-dead' : 'mdi-robot-off'"
                            :text="`Build #${history.ID }`"
                            :color="history.State === 'Failed' ? 'white' : 'grey darken-2'" 
                            :text-color="history.State === 'Failed' ? 'white--text' : 'grey--text text--darken-2'"
                        />
                    </v-card>
                    <infinity-separator
                        icon="mdi-text-long"
                        text="Logs"
                        class="mt-6"
                    />
                    <log-viewer 
                        :log="history.Logs || ''"
                    />
                </v-container>           
            </div>        
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'pinia'
    import { useAppStore } from '@/store/app-store'
    import LogViewer from '@femessage/log-viewer'
    import VJsf from '@koumoul/vjsf/lib/VJsf.js'
    import axios from 'axios'
    import schema from '@/assets/schemas/app/setting.json'
    export default {
        components: {
            LogViewer,
            VJsf,
        },
        data: () => ({
            tick: null,
            logs: '',
            tab: 0,
            model: {},
            history: {},
            schema: {
                readOnly: true,
                ...schema,
            },
            options: {
                httpLib: axios,
                fieldProps: {
                    outlined: true,
                },
                arrayItemColProps: { cols: 12 },
                arrayItemCardProps: {
                    outlined: true,
                    hover: true,
                    shaped: true,
                    style: 'margin: 10px',
                },
            },
        }),        
        computed: {
            ...mapState(useAppStore, ['builds', 'loading']),
            buildId () {
                return this.$route.params.jobId
            },
            tags () {
                const tags = this.history.Tags
                if (!tags) {
                    return []
                }
                return JSON.parse(tags)?.builds || []
            },
        }, 
        watch: {
            history (v) {
                this.model = {}
                const appConfig = this.history.AppConfig
                if (!appConfig) {
                    return {}
                }
                setTimeout(() => {
                    this.model = JSON.parse(appConfig)    
                }, 10)                
            },
            async '$route.params' () {
                await this.load()
            },
        },
        async mounted () {     
            await this.load()       
        },        
        unmounted () {
            clearInterval(this.tick)
        },
        beforeRouteLeave (to, from, next) {
            clearInterval(this.tick)
            next()
        },
        beforeDestroy () {
            clearInterval(this.tick)
        },
        deactivated () {
            clearInterval(this.tick)
        },
        methods: {
            ...mapActions(useAppStore, ['loadBuildLogs', 'loadBuildHistory']),
            async load () {
                if (this.buildId === 'running') {                
                    this.logs = await this.loadBuildLogs(this.$route.params.universe, this.$route.params.app)                
                    this.tick = setInterval(async () => {
                        this.logs = await this.loadBuildLogs(this.$route.params.universe, this.$route.params.app)
                    }, [2500, 2900, 3300, 3700, 4100][Math.floor(Math.random() * 5)])
                    return
                }
                this.history = await this.loadBuildHistory(this.$route.params.universe, this.$route.params.app, this.buildId)
            },
        },
    }
</script>
